import _ from 'lodash';

import * as api from '../api';

export const fetchPatientData = _.memoize(async (authCode: string) =>
  api.client.Previsit.fetchPatient(authCode),
);

export const startPrevisitFormSet = _.memoize(
  (formSetId: string, authCode: string) =>
    api.client.Previsit.startFormSet(formSetId, authCode),
);

// Cache clear

const memoizedFunctions: _.MemoizedFunction[] = [];
memoizedFunctions.push(fetchPatientData);
memoizedFunctions.push(startPrevisitFormSet);

export const clearCache = () => {
  memoizedFunctions.forEach((f) => {
    if (f.cache.clear) {
      f.cache.clear();
    }
  });
};
